import { Tooltip } from "@mui/material";
import { ArrowCircleRightOutlined, CancelOutlined, CheckCircleOutline } from "@mui/icons-material";
import { InstanceStatus } from "../../../../types/actionModule/actionModuleInstance";
import { useTranslation } from "react-i18next";

interface InstanceStatusIconProps {
    status: InstanceStatus;
}

export default function InstanceStatusIcon(props: InstanceStatusIconProps) {
    const { t } = useTranslation();

    switch (props.status) {
        case InstanceStatus.Open:
            return <Tooltip title={t("incentivationPage.instanceStatus.open")}>
                <ArrowCircleRightOutlined color="disabled" />
            </Tooltip>;
        case InstanceStatus.Completed:
            return <Tooltip title={t("incentivationPage.instanceStatus.completed")}>
                <CheckCircleOutline color="success" />
            </Tooltip>;
        case InstanceStatus.Closed:
        case InstanceStatus.Orphaned:
            return <Tooltip title={t("incentivationPage.instanceStatus.closed")}>
                <CancelOutlined color="error" />
            </Tooltip>;
    }
}